export const styles = () => ({
  minHeight: '100vh',
  position: 'relative',
  background: 'url(https://resources.datanomik.com/dashboard/images/login-bg.svg) center center no-repeat, url(https://resources.datanomik.com/dashboard/images/bg-public.jpg) center center no-repeat',
  backgroundSize: 'cover',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  '.dn-button-primary.MuiButton-contained': {
    borderRadius: '500px !important',
    minWidth: '150px !important',
    background: '#2845D2 !important',
    color: '#ffffff !important',
    padding: '8px 25px !important',
    lineHeight: '1 !important',
    minHeight: '40px',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#1431c2 !important',
      color: '#ffffff !important',
    },
  },
  '.dn-button-secondary.MuiButton-outlined': {
    borderRadius: '500px !important',
    minWidth: '150px !important',
    backgroundColor: '#fff !important',
    color: '#2845d2 !important',
    border: '1px solid #2845d2 !important',
    padding: '8px 25px !important',
    lineHeight: '1 !important',
    minHeight: '40px',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#e5f5ff !important',
      color: '#2845d2 !important',
    },
  },
  '.dn-404-text': {
    fontWeight: '800',
    fontSize: '100px',
    lineHeight: '100px',
    color: '#2845D2',
    marginBottom: '24px',
  },
});
